"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProfileModal = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _noty = require("noty");

var _userProfile = require("user-profile");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

// import { show as showSuccessBanner } from 'success-banner';
var ProfileModal =
/*#__PURE__*/
function (_Modal) {
  babelHelpers.inherits(ProfileModal, _Modal);

  function ProfileModal() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ProfileModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ProfileModal)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this.modalBodyInnerClasses = ['col-md-6', 'col-md-offset-3'];
    return _this;
  }

  babelHelpers.createClass(ProfileModal, [{
    key: "getModalContent",
    value: function getModalContent() {
      var _this2 = this;

      return (0, _userProfile.getUserProfile)().then(function (data) {
        _this2.profile = data;
        var fixed = data.fixed,
            defaultPhoto = data.defaultPhoto,
            isEmailAccount = data.isEmailAccount,
            system = data.system;
        var rv = "\n\t\t\t\t".concat(isEmailAccount ? "\n\t\t\t\t\t<div class='btn-group btn-group-justified' role='tablist'>\n\t\t\t\t\t\t<a data-target='#profileUpdate' role='tab' class='active btn btn-primary' data-toggle='tab' href='javascript:void(0)'>\n\t\t\t\t\t\t\tEdit Profile\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a data-target='#passwordUpdate' role='tab' class='btn btn-primary change-password-tab' data-toggle='tab' href='javascript:void(0)'>\n\t\t\t\t\t\t\tChange Password\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t" : '', "\n\t\t\t\t<div class='tab-content'>\n\t\t\t\t\t<div class='tab-pane active' role='tabpanel' id='profileUpdate'>\n\t\t\t\t\t\t<iframe id='profileUpdateTarget' style='position: fixed; top: -1000px; left: -1000px; width: 100px; height: 100px;' name='profileUpdateTarget'></iframe>\n\t\t\t\t\t\t<form role='form' method='post' action='userProfile' enctype='multipart/form-data' target='profileUpdateTarget'>\n\t\t\t\t\t\t\t<input type='hidden' name='event' value='profileUpdateHandler'>\n\t\t\t\t\t\t\t<div class='form-group photo-group'>\n\t\t\t\t\t\t\t\t<div class='row sr-only'>\n\t\t\t\t\t\t\t\t\t<div class='col-sm-12'>\n\t\t\t\t\t\t\t\t\t\t<label for='photo'>Photo</label>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class='row'>\n\t\t\t\t\t\t\t\t\t<div class='col-sm-3 col-i-6 col-l-4 account-image'>\n\t\t\t\t\t\t\t\t\t\t<img src='").concat(defaultPhoto, "' class='thumbnail img-responsive thumbnail-placeholder'>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class='col-sm-9 col-i-6 col-l-8 upload-wrapper'>\n\t\t\t\t\t\t\t\t\t\t<h3>Profile Image</h3>\n\t\t\t\t\t\t\t\t\t\t<div id='profile-file-upload'>\n\t\t\t\t\t\t\t\t\t\t\t<button class='btn btn-default btn-sm' type='button'>Select Image</button>\n\t\t\t\t\t\t\t\t\t\t\t<input type='file' class='file-selector' name='photo' id='photo' accept='image/*'>\n\t\t\t\t\t\t\t\t\t\t\t<div class='photo-info'>\n\t\t\t\t\t\t\t\t\t\t\t\t<p>Your photo must be a non-copyrighted image in JPG, PNG, or GIF format with a maximum file size of 2MB.</p>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class='form-group'>\n\t\t\t\t\t\t\t\t<label for='username'>Email Address</label>\n\t\t\t\t\t\t\t\t<input id='username' class='input-lg form-control' name='username' type='email' value=''>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class='form-group'>\n\t\t\t\t\t\t\t\t<label for='fullName'>Name</label>\n\t\t\t\t\t\t\t\t<input id='fullName' class='input-lg form-control' name='fullName' type='text' value=''>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class='form-group'>\n\t\t\t\t\t\t\t\t<label for='nickname'>Nickname</label>\n\t\t\t\t\t\t\t\t<input id='nickname' class='input-lg form-control' name='nickname' type='text' value=''>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t").concat(system.hasMarketingOptIn ? "\n\t\t\t\t\t\t\t\t\t<div class='checkbox'>\n\t\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t\t<input type='checkbox'>\n\t\t\t\t\t\t\t\t\t\t\t<span id='marketingOptInText'></span>\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t<input type='hidden' id='marketingOptIn' name='marketingOptIn' value=''>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t" : '', "\n\t\t\t\t\t\t\t<div class='form-actions'>\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t<button type='submit' class='btn btn-primary' data-spin='true'>Save</button>\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</form>\n\t\t\t\t\t</div>\n\t\t\t\t\t").concat(isEmailAccount ? "\n\t\t\t\t\t\t\t<div class='tab-pane' role='tabpanel' id='passwordUpdate'>\n\t\t\t\t\t\t\t\t<form role='form' method=''>\n\t\t\t\t\t\t\t\t\t<div class='form-group'>\n\t\t\t\t\t\t\t\t\t\t<label for='currentPassword'>Current password</label>\n\t\t\t\t\t\t\t\t\t\t<input name='currentPassword' id='currentPassword' class='form-control input-lg' type='password'>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class='form-group'>\n\t\t\t\t\t\t\t\t\t\t<label for='password'>New password</label>\n\t\t\t\t\t\t\t\t\t\t<div class='input-group'>\n\t\t\t\t\t\t\t\t\t\t\t<input name='password' id='password' type='password' class='form-control input-lg'>\n\t\t\t\t\t\t\t\t\t\t\t<div class='input-group-btn'>\n\t\t\t\t\t\t\t\t\t\t\t\t<a class='btn btn-default password-help'\n\t\t\t\t\t\t\t\t\t\t\t\t\tdata-toggle='popover'\n\t\t\t\t\t\t\t\t\t\t\t\t\ttitle='Password Requirements'\n\t\t\t\t\t\t\t\t\t\t\t\t\trole='button'\n\t\t\t\t\t\t\t\t\t\t\t\t\tdata-html='true'\n\t\t\t\t\t\t\t\t\t\t\t\t\tdata-trigger='click'\n\t\t\t\t\t\t\t\t\t\t\t\t\tdata-placement='right auto'\n\t\t\t\t\t\t\t\t\t\t\t\t\tdata-content='<ul>".concat(['A minimum of 6 characters', 'Use at least one number', 'Use at least one uppercase letter'].map(function (v) {
          return "<li>".concat(v, "</li>");
        }).join(''), "</ul>'\n\t\t\t\t\t\t\t\t\t\t\t\t\ttabindex='-1'\n\t\t\t\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class='material-icons' data-icon='help'></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class='form-actions'>\n\t\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t\t<button class='btn btn-primary' type='submit' data-spin='true'>Save</button>\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t") : '', "\n\t\t\t\t</div>\n\t\t\t");
        return rv;
      });
    }
  }, {
    key: "setupBindings",
    value: function setupBindings(element) {
      var _this3 = this;

      var fileUpload = element.querySelector('#profile-file-upload');
      var fileField = fileUpload.querySelector('input[type=file]');
      fileField.addEventListener('focus', function () {
        setTimeout(function () {
          if (document.activeElement == fileField) fileField.blur();
        }, 16);
      });
      var imgContent = element.querySelector('.account-image').innerHTML;
      var URL = window.URL || window.webkitURL;

      if (URL) {
        var previousURL = null;
        fileField.addEventListener('change', function () {
          if (previousURL) URL.revokeObjectURL(previousURL);

          if (fileField.files.length) {
            var f = fileField.files[0];
            var url = URL.createObjectURL(f);
            previousURL = url;
            element.querySelector('.account-image').innerHTML = "<img src=\"".concat(url, "\" class=\"thumbnail img-responsive\">");
          } else {
            previousURL = null;
            element.querySelector('.account-image').innerHTML = imgContent;
          }
        });
      }

      var pwForm = element.querySelector('#passwordUpdate form');

      if (pwForm) {
        pwForm.addEventListener('submit', function (event) {
          event.preventDefault();
          var currentPassword = pwForm.querySelector('#currentPassword').value,
              newPassword = pwForm.querySelector('#password').value;
          var fData = {
            currentPassword: currentPassword,
            newPassword: newPassword
          };

          if (currentPassword && newPassword && newPassword.length >= 8) {
            (0, _fetch.default)('account/updatePassword', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                currentPassword: currentPassword,
                password: newPassword
              })
            }).then(function (response) {
              if (response.ok) {
                _classList.default.remove(pwForm.querySelector('.btn.spinning'), 'spinning');

                [].forEach.call(pwForm.querySelectorAll('.alert'), function (node) {
                  return node.parentNode.removeChild(node);
                });
                (0, _noty.showNotificationText)('Your password has been changed.');
                pwForm.reset();
              } else {
                response.json().then(function (object) {
                  var e = document.createElement('div');
                  e.className = 'alert alert-danger';
                  e.textContent = JSON.parse(xhr.responseText).error;
                  pwForm.insertBefore(e, pwForm.firstChild);
                  pwForm.querySelector('#currentPassword').focus();
                });
              }
            });
            return false;
          }

          [].forEach.call(pwForm.querySelectorAll('.alert'), function (node) {
            return node.parentNode.removeChild(node);
          });
          var e = document.createElement('div');
          e.className = 'alert alert-danger';
          if (!currentPassword || !newPassword) e.textContent = 'Please specify your current password & a new password.';else if (newPassword.length < 8) e.textContent = 'Please specify a new password of at least 8 characters.';
          pwForm.insertBefore(e, pwForm.firstChild);
          pwForm.querySelector(currentPassword ? '#password' : '#currentPassword').focus();

          _classList.default.remove(pwForm.querySelector('.btn.spinning'), 'spinning');

          return false;
        });
      }

      $(document).off('.profileModal').on('profileUpdateHandler.profileModal', function (event) {
        _classList.default.remove(element.querySelector('#profileUpdate .btn.spinning'), 'spinning');

        if (event.responseCode == 200) {
          (0, _noty.showNotificationText)('Your profile has been updated.');
          ClientAPI.emptyCache();
          (0, _userProfile.userProfileUpdated)();

          _this3.updateContents(element, event.body);
        } else {
          [].forEach.call(element.querySelectorAll('#profileUpdate .alert'), function (node) {
            return node.parentNode.removeChild(node);
          });
          var e = document.createElement('div');
          e.className = 'alert alert-danger';
          e.textContent = event.body.errorMessage;
          var q = element.querySelector('#profileUpdate form');
          q.insertBefore(e, q.firstChild);
        }
      });
      $(element).find('[data-toggle="popover"]').popover();
      $(element).find('.btn-group a[data-toggle=tab]').on('show.bs.tab', function (_ref) {
        var target = _ref.currentTarget;
        $(element).find('a[data-toggle=tab]').removeClass('active');
        $(target).addClass('active');
      });

      if (this.profile.system.hasMarketingOptIn) {
        var pu = element.querySelector('#profileUpdate');
        var cb = pu.querySelector('#marketingOptIn');

        if (cb) {
          cb = cb.parentNode.querySelector('input[type=checkbox]');

          if (cb && !cb.dataset.hasClickListener) {
            cb.addEventListener('click', function () {
              pu.querySelector('#marketingOptIn').value = this.checked ? '1' : '';
            });
            cb.dataset.hasClickListener = '1';
          }
        }
      }

      this.updateContents(element, this.profile);
    }
  }, {
    key: "updateContents",
    value: function updateContents(element, profile) {
      this.profile = profile;
      var pu = element.querySelector('#profileUpdate');
      var fixed = profile.fixed,
          photo = profile.photo,
          defaultPhoto = profile.defaultPhoto,
          isEmailAccount = profile.isEmailAccount,
          system = profile.system;

      if (system.hasMarketingOptIn) {
        pu.querySelector('#marketingOptInText').textContent = system.optInText;
        pu.querySelector('#marketingOptIn').value = profile.marketingOptIn ? '1' : '';
        pu.querySelector('#marketingOptIn').parentNode.querySelector('input[type=checkbox]').checked = profile.marketingOptIn;
      }

      if (photo) pu.querySelector('.account-image').innerHTML = "<img class='thumbnail img-responsive' src='".concat(photo, "'>");else pu.querySelector('.account-image').innerHTML = "<img class='thumbnail img-responsive thumbnail-placeholder' src='".concat(defaultPhoto, "'>");
      if (fixed.photo) _classList.default.add(pu.querySelector('#profile-file-upload'), 'hidden');else _classList.default.remove(pu.querySelector('#profile-file-upload'), 'hidden');

      if (isEmailAccount) {
        var lbl = pu.querySelector('label[for=username]');
        [].forEach.call(lbl.querySelectorAll('small'), function (node) {
          return node.parentNode.removeChild(node);
        });
        lbl.innerHTML += " <small>Used for sign-in and password retrieval</small>";
      }

      ['username', 'fullName', 'nickname'].forEach(function (field) {
        var f = pu.querySelector("#".concat(field));
        f.value = profile[field];
        f.required = f.disabled = false;

        if (fixed[field]) {
          f.disabled = true;
        } else if (field != 'nickname') {
          f.required = true;
        }

        if (f.type == 'select-one') $(f).trigger('chosen:updated');
      });
    }
  }, {
    key: "append",
    value: function append() {
      var _babelHelpers$get,
          _this4 = this;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return (_babelHelpers$get = babelHelpers.get(babelHelpers.getPrototypeOf(ProfileModal.prototype), "append", this)).call.apply(_babelHelpers$get, [this].concat(args)).then(function (element) {
        _this4.setupBindings(element);

        return element;
      });
    }
  }, {
    key: "icon",
    get: function get() {
      return "\n\t\t\t<span class='img-icon img-icon-user'>\n\t\t\t\t<img src='/t/width=1/height=1/cover/width=30/height=30/matte=none/scale/f".concat(this.profile.photo || this.profile.defaultPhoto, "/user-photo.png' class='img-circle'>\n\t\t\t</span>\n\t\t");
    }
  }, {
    key: "title",
    get: function get() {
      return 'My Account';
    }
  }, {
    key: "subTitle",
    get: function get() {
      return this.profile.nickname || this.profile.fullName;
    }
  }], [{
    key: "setupProfile",
    value: function setupProfile(data) {
      Object.assign(this, data);
    }
  }]);
  return ProfileModal;
}(_base.default);

exports.ProfileModal = ProfileModal;
var instance = new ProfileModal('profile-sidebar-modal');
var _default = instance;
exports.default = _default;